<template>
    <validation-provider class="form-input-field tw-flex tw-flex-col tw-flex-1 tw-relative" :rules="rules" :name="name" :vid="vid" v-slot="{ errors, classes }">
        <label class="form-label" v-text="label" v-if="label"></label>
        <div class="form-input-wrapper tw-flex tw-relative" :class="classes">
            <textarea class="tw-flex-1 v2-input" :type="type" v-model="currentValue" :placeholder="placeholder" v-autofocus="autofocus"></textarea>
        </div>
        <span class="form-validation-error" v-if="errors.length > 0">{{ errors[0] }}.</span>
        <p class="helper" v-if="helper" v-text="helper"></p>
    </validation-provider>
</template>

<script>
    import FormInput from '../../../mixins/FormInput';
    import Validation from '../../../mixins/v2/Validation';

    export default {
        name: 'FormTextarea',

        mixins: [FormInput, Validation],

        props: {
            autofocus: {
                default: false,
            },
        },
    };
</script>
